import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=7844c5d5&scoped=true&"
import script from "./CommonHeader.vue?vue&type=script&lang=js&"
export * from "./CommonHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=7844c5d5&lang=less&scoped=true&"
import style1 from "./CommonHeader.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844c5d5",
  null
  
)

export default component.exports